const x = {
  xs: "12px",
  sm: "14px",
  md: "16px",
  lg: "18px",
  xl: "20px",
  "2xl": "24px",
  "3xl": "28px",
  "4xl": "36px",
  "5xl": "48px",
  "6xl": "64px"
}, l = {
  xs: { fontSize: x.xs },
  sm: { fontSize: x.sm },
  md: { fontSize: x.md },
  lg: { fontSize: x.lg },
  xl: { fontSize: x.xl },
  "2xl": { fontSize: x["2xl"] },
  "3xl": { fontSize: x["3xl"] },
  "4xl": { fontSize: x["4xl"] },
  "5xl": { fontSize: x["5xl"] },
  "6xl": { fontSize: x["6xl"] }
};
export {
  l as iconSizeStyles,
  x as iconSizes
};
